import { Link } from 'react-router-dom';
import type { AssignmentEntityType } from 'domain/shared/assignment';
import { AssignmentTargetType } from 'domain/shared/assignment/target/shared/assignmentTargetService';
import { ProjectLink, READ_PROJECT } from 'domain/shared/project';
import { READ_SERVICE, ServiceLink } from 'domain/shared/service';
import { useServiceCatalogService, useServiceCatalogUrl } from 'domain/shared/serviceCatalog';
import { useAuthorization } from 'framework/authorization';
import { InputLoader } from 'framework/ui/mui-builder';
import { EMPTY_VALUE_INDICATOR, useAsyncValue } from 'framework/utils';

const CatalogTargetLink = ({ id }: { id: number }) => {
  const { getServiceSuggestions } = useServiceCatalogService();
  const { getSingleEntityUrl } = useServiceCatalogUrl();
  const data = useAsyncValue(
    () => getServiceSuggestions({ filter: { id: { eq: id } } }).catch(() => ({ result: [] })),
    [id],
  );

  if (!data) return <InputLoader />;
  return <Link to={getSingleEntityUrl(id)}>{data.result?.[0]?.name || id}</Link>;
};

const AssignmentTargetLink = ({ target }: { target: AssignmentEntityType['target'] }) => {
  const { isGranted } = useAuthorization();

  switch (target?.type) {
    case AssignmentTargetType.PROJECT:
      return <ProjectLink id={target.id} name={target.displayName} isClickable={isGranted(READ_PROJECT)} />;
    case AssignmentTargetType.SERVICE:
      return <ServiceLink id={target.id} name={target.displayName} isClickable={isGranted(READ_SERVICE)} />;
    case AssignmentTargetType.SERVICE_CATALOG_SERVICE:
      return target.targetId ? <CatalogTargetLink key={target.targetId} id={target.targetId} /> : EMPTY_VALUE_INDICATOR;
    default:
      return EMPTY_VALUE_INDICATOR;
  }
};

export default AssignmentTargetLink;
